<template>
  <div class="app-footer">
    <div class="app-footer-content">
      <div class="social-list">
        <div
          class="social-item"
          v-for="item in state.socialList"
          :key="item.name"
          v-show="item.url"
        >
          <a :href="item.url" target="_blank" rel="noopener noreferrer">
            <img :src="item.img" alt="social">
          </a>
        </div>
      </div>
      <div class="link-list">
        <div class="link-item" v-for="item in state.linkList" :key="item.name">
          <a :href="item.url" target="_blank" rel="noopener noreferrer">
            {{ item.name }}
          </a>
        </div>
      </div>
      <div class="footer-text">
        {{ $t('footer.text') }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import fbIcon from '@/assets/imgs/icon-fb.png'
import fbGroupIcon from '@/assets/imgs/icon-fb-group.png'
import dcIcon from '@/assets/imgs/icon-dc.png'
import ytIcon from '@/assets/imgs/icon-yt.png'
import ttIcon from '@/assets/imgs/icon-tt.png'

const { t } = useI18n()

// 文案 / 跳转随语言包 footer.* 变化；空链接的社交项不展示
const state = reactive({
  socialList: [
    {
      name: 'fb',
      url: computed(() => t('footer.jumpLink.fb')),
      img: fbIcon,
    },
    {
      name: 'fb-group',
      url: computed(() => t('footer.jumpLink.fbGroup')),
      img: fbGroupIcon,
    },
    {
      name: 'dc',
      url: computed(() => t('footer.jumpLink.dc')),
      img: dcIcon,
    },
    {
      name: 'yt',
      url: computed(() => t('footer.jumpLink.yt')),
      img: ytIcon,
    },
    {
      name: 'tt',
      url: computed(() => t('footer.jumpLink.tt')),
      img: ttIcon,
    },
  ],
  linkList: [
    {
      name: computed(() => t('footer.link.security')),
      url: computed(() => t('footer.jumpLink.security')),
    },
    {
      name: computed(() => t('footer.link.privacy')),
      url: computed(() => t('footer.jumpLink.privacy')),
    },
  ],
})
</script>

<style lang="less" scoped>
.app-footer {
  width: 100%;
  background-color: #000;
  position: relative;
  z-index: 10;

  .app-footer-content {
    width: 750px;
    max-width: 100%;
    padding: 50px 15px;
    margin: 0 auto;
    box-sizing: border-box;
  }

  .social-list {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin: 0 auto;
    gap: 50px;

    &::after {
      content: '';
      display: block;
      width: 100%;
      height: 1px;
      background: linear-gradient(
        to right,
        transparent 0%,
        #333 50px,
        #333 calc(100% - 50px),
        transparent 100%
      );
      position: absolute;
      bottom: -30px;
      left: 0;
    }

    .social-item {
      img {
        width: 100px;
        display: block;
      }
    }
  }

  .link-list {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 50px;
    margin-top: 80px;

    .link-item {
      border-right: 1px solid #6d6767;
      padding-right: 50px;
      display: flex;

      &:last-child {
        border-right: none;
        padding-right: 0;
      }

      a {
        font-size: 22px;
        color: #6d6767;
        position: relative;

        &::after {
          content: '';
          display: block;
          width: 100%;
          height: 1px;
          background-color: #6d6767;
          position: absolute;
          bottom: 0;
        }
      }
    }
  }

  .footer-text {
    font-size: 22px;
    color: #ffffff;
    text-align: center;
    margin-top: 50px;
    line-height: 1.5;
    word-break: normal;
    overflow-wrap: break-word;
  }
}
</style>
